import React, { useState } from 'react';
import BlogCategoryEditModal from '../components/AdminBlogCategoriesPage/BlogCategoryEditModal';
import BlogCategoryAddModal from '../components/AdminBlogCategoriesPage/BlogCategoryAddModal';
import BlogCategoryDeleteModal from '../components/AdminBlogCategoriesPage/BlogCategoryDeleteModal';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import BlogCategoriesTable from '../components/AdminBlogCategoriesPage/BlogCategoriesTable';
import BlogCategoriesBulkActions from '../components/AdminBlogCategoriesPage/BlogCategoriesBulkActions';
import { useBlogCategoryActions } from '../hooks/AdminBlogCategoriesPage/useBlogCategoryActions';
import AdminTableLoadingSpinner from '../components/Common/AdminTableLoadingSpinner';
import '../styles/AdminPage.css';

const AdminBlogCategoriesPage = () => {
  const [editCategory, setEditCategory] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(null);

  const {
    filteredCategories,
    selectedCategories,
    clearSelectedCategories,
    loadCategories,
    handleFilter,
    handleSelectAll,
    handleCategorySelect,
    isLoading,
  } = useBlogCategoryActions();

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
        <h1>Blog Categories</h1>
      </div>

      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleFilter} />
          <BlogCategoriesBulkActions
            selectedCategories={selectedCategories}
            clearSelectedCategories={clearSelectedCategories}
            loadCategories={loadCategories}
          />
          <div className="admin-page__tools_buttons">
            <button className="button primary" onClick={() => setIsAddModalOpen(true)}>
              Add Blog Category
            </button>
          </div>
        </div>

        {isLoading ? (
          <AdminTableLoadingSpinner />
        ) : (
          <>
            <BlogCategoriesTable
              categories={filteredCategories || []}
              onEdit={setEditCategory}
              onDelete={setDeleteCategory}
              onCategorySelect={handleCategorySelect}
              selectedCategories={selectedCategories}
              onSelectAll={handleSelectAll}
            />
            <div className="admin-page__footer">
              <p>Blog categories count: {filteredCategories?.length || 0}</p>
            </div>
          </>
        )}
      </div>

      <BlogCategoryEditModal
        isOpen={!!editCategory}
        onClose={() => setEditCategory(null)}
        onSuccess={() => {
          loadCategories();
          setEditCategory(null);
        }}
        category={editCategory}
      />

      <BlogCategoryAddModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={() => {
          loadCategories();
          setIsAddModalOpen(false);
        }}
      />

      <BlogCategoryDeleteModal
        isOpen={!!deleteCategory}
        onClose={() => setDeleteCategory(null)}
        onSuccess={() => {
          loadCategories();
          setDeleteCategory(null);
        }}
        category={deleteCategory}
      />
    </div>
  );
};

export default AdminBlogCategoriesPage; 